import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';

import { videoPublicUrl } from '../../../setPublicPath';
import styles from './index.module.css';
import { RESET_POPUP } from './actions';
import { UPDATE_BALANCE } from '@components/containers/user-info-block/actions';
import Dropdown from '@components/common/dropdown';
import ScrollBlock from '@components/common/scroll-block';
import ScrollBlockImage from '@components/common/scroll-block-image';
import Button from '@components/common/button';
import IconButton from '@components/common/icon-button';

import commonStyles from '@styles/common.module.css';

import testingDataAPI from '@utils/testingAPI';
import comm from '@utils/comm';
import { error_custom_prefix, error_retry_prefix } from '@utils/comm';
import utils from '@utils';

import testingAPI from '@utils/testingGUIAPI';

import alMilankovitch from '@images/characters/alMilankovitch.jpg';
import andyQuated from '@images/characters/andyQuated.jpg';
import annOYing from '@images/characters/annOYing.jpg';
import arthurRizer from '@images/characters/arthurRizer.jpg';
import aydenFigurz from '@images/characters/aydenFigurz.jpg';
import berthaSurtifiket from '@images/characters/berthaSurtifiket.jpg';
import bettySangre from '@images/characters/bettySangre.jpg';
import billDupwerdz from '@images/characters/billDupwerdz.jpg';
import bobBurnham from '@images/characters/bobBurnham.jpg';
import bobSeekias from '@images/characters/bobSeekias.jpg';
import budJetter from '@images/characters/budJetter.jpg';
import carlaDriver from '@images/characters/carlaDriver.jpg';
import connieFerm from '@images/characters/connieFerm.jpg';
import deeSkustin from '@images/characters/deeSkustin.jpg';
import drewSkech from '@images/characters/drewSkech.jpg';
import edwardUKaterz from '@images/characters/edwardUKaterz.jpg';
import emmaTea from '@images/characters/emmaTea.jpg';
import eveAder from '@images/characters/eveAder.jpg';
import floraBlume from '@images/characters/floraBlume.jpg';
import hectorFowler from '@images/characters/hectorFowler.jpg';
import irisTakz from '@images/characters/irisTakz.jpg';
import jakeMilankovitch from '@images/characters/jakeMilankovitch.jpg';
import jamesFallow from '@images/characters/jamesFallow.jpg';
import liddieGaeshon from '@images/characters/liddieGaeshon.jpg';
import mannyArbor from '@images/characters/mannyArbor.jpg';
import mariNer from '@images/characters/mariNer.jpg';
import nateTurlover from '@images/characters/nateTurlover.jpg';
import nodizEsis from '@images/characters/nodizEsis.jpg';
import poThole from '@images/characters/poThole.jpg';
import pueBirdie from '@images/characters/pueBirdie.jpg';
import reggieStirz from '@images/characters/reggieStirz.jpg';
import rheaKruter from '@images/characters/rheaKruter.jpg';
import ritaLott from '@images/characters/ritaLott.jpg';
import ronnaFares from '@images/characters/ronnaFares.jpg';
import samKeystone from '@images/characters/samKeystone.jpg';
import seymourMappes from '@images/characters/seymourMappes.jpg';
import sheaDBisnez from '@images/characters/sheaDBisnez.jpg';
import stanOGrafir from '@images/characters/stanOGrafir.jpg';
import stewRuxtur from '@images/characters/stewRuxtur.jpg';
import sueSpishus from '@images/characters/sueSpishus.jpg';
import tillieTerrain from '@images/characters/tillieTerrain.jpg';
import tomVerde from '@images/characters/tomVerde.jpg';
import wylieKettle from '@images/characters/wylieKettle.jpg';

import contractPdf from '@images/documentsDownload/contract.pdf';
import fireAlarmPdf from '@images/documentsDownload/fireAlarm.pdf';
import fireIncidentPdf from '@images/documentsDownload/fireIncident.pdf';
import policeReportPdf from '@images/documentsDownload/policeReport.pdf';
import purchaseOrderPdf from '@images/documentsDownload/purchaseOrder.pdf';
import reconPdf from '@images/documentsDownload/recon.pdf';
import sanitationReportPdf from '@images/documentsDownload/sanitationReport.pdf';
import siteWellDataPdf from '@images/documentsDownload/siteWellData.pdf';
import slBrochurePdf from '@images/documentsDownload/slBrochure.pdf';
import slCatalogPdf from '@images/documentsDownload/slCatalog.pdf';
import slMapPdf from '@images/documentsDownload/slMap.pdf';
import wellRecordPdf from '@images/documentsDownload/wellRecord.pdf';

const pdfDocs = {
  contract: contractPdf,
  fireAlarm: fireAlarmPdf,
  fireIncident: fireIncidentPdf,
  policeReport: policeReportPdf,
  purchaseOrder: purchaseOrderPdf,
  recon: reconPdf,
  sanitationReport: sanitationReportPdf,
  siteWellData: siteWellDataPdf,
  slBrochure: slBrochurePdf,
  slCatalog: slCatalogPdf,
  slMap: slMapPdf,
  wellRecord: wellRecordPdf,
};

const charImgs = {
  alMilankovitch,
  andyQuated,
  annOYing,
  arthurRizer,
  aydenFigurz,
  berthaSurtifiket,
  bettySangre,
  billDupwerdz,
  bobBurnham,
  bobSeekias,
  budJetter,
  carlaDriver,
  connieFerm,
  deeSkustin,
  drewSkech,
  edwardUKaterz,
  emmaTea,
  eveAder,
  floraBlume,
  hectorFowler,
  irisTakz,
  jakeMilankovitch,
  jamesFallow,
  liddieGaeshon,
  mannyArbor,
  mariNer,
  nateTurlover,
  nodizEsis,
  poThole,
  pueBirdie,
  reggieStirz,
  rheaKruter,
  ritaLott,
  ronnaFares,
  samKeystone,
  seymourMappes,
  sheaDBisnez,
  stanOGrafir,
  stewRuxtur,
  sueSpishus,
  tillieTerrain,
  tomVerde,
  wylieKettle,
};

let docImgs = {};
let youtubeVideos = [
  [
    'https://www.youtube.com/embed/pz9eTvJea9Y',
    'https://www.youtube.com/embed/zswLL6qhy8s',
  ],
];
let docInternalNames = comm.dataStore.docINames.map(doc => ({
  name: doc.internalName,
  rg: new RegExp(doc.internalName + '\\d+\\.(png|jpe?g)$'),
}));
function testIName(name) {
  for (let i = 0; i < docInternalNames.length; i++) {
    if (docInternalNames[i].rg.test(name)) {
      return docInternalNames[i].name;
    }
  }
  return false;
}

function importAll(r) {
  return r.keys().forEach(name => {
    let docName = testIName(name);
    if (docName) {
      if (docName in docImgs) docImgs[docName].push(r(name));
      else docImgs[docName] = [r(name)];
    }
  });
}

importAll(require.context('@images/documents', false, /\d+\.(png|jpe?g)$/));

const ERROR_MSG = {
  error_drill_invalid:
    'You have entered invalid coordinates. Please enter coordinates which are multiples of ten.',
  error_drill_exhaustion:
    'You may not drill any more holes at this location. Please try again at different coordinates.',
  error_too_far_100:
    'You have entered invalid coordinates. Please enter coordinates no more than 100 feet apart.',
  error_too_far_230:
    'You have entered invalid coordinates. Please enter coordinates no more than 230 feet apart.',
  error_not_aligned:
    'You have entered invalid coordinates. Please enter coordinates horizontally or vertically aligned.',
  error_too_short:
    'You have entered invalid coordinates. The transect must extend at least 10 feet.',
  error_no_sublocation:
    'You must choose a [sublocation] to visit. Please select one from the dropdown menu above the visit button.',
  error_custom: message => 'An error occurred loading data:|' + message,
};

function DBoxWithFoundation(foundation) {
  class DrillingDBoxBuilder extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        drillPushValue: 0,
        wallElevationValue: 0,
      };

      let testMethod = testingAPI.testState.method;
      this.testMethod = testMethod;
      let testMethodLabel = testMethod === 'push' ? 'Direct Push' : 'Drilling'; // this is the header also
      this.testMethodLabel = testMethodLabel;
      this.testMethodBtnLabel = testMethod === 'push' ? 'Push' : 'Drill';
      let price = testMethod === 'push' ? 25 : 525;
      let geoData = testingAPI.testState.geoData;
      let testZ = testingAPI.testState.z;
      let _loc13 = geoData.surface - 100;
      let canContinue =
        foundation !== 'bedrock' &&
        !(testMethod === 'push' && testZ < _loc13 + 10);
      this.canContinue = canContinue;
      let testDataWell = comm.dataStore.getTestData(
        'well',
        testingAPI.testState.x,
        testingAPI.testState.y,
      );

      let txtFieldInfo = '';
      txtFieldInfo =
        testMethodLabel + ' has reached an elevation of ' + testZ + 'ft';
      if (foundation === 'waterTable') {
        txtFieldInfo += ' and has breached the water table';
        if (geoData.floatingGasThickness > 0) {
          txtFieldInfo +=
            '. There is a layer of gas floating on top of the water';
        }
      } else if (foundation === 'bedrock') {
        txtFieldInfo +=
          ', which is less than 10 feet from bedrock. You cannot continue further';
      }
      txtFieldInfo += '.\r\r';
      txtFieldInfo +=
        'You may install a well screened at this elevation (or higher) at a cost of $500, ';
      if (canContinue) {
        txtFieldInfo +=
          'continue ' +
          testMethod +
          'ing deeper at a cost of $' +
          price +
          ' per 10 feet, ';
      }
      txtFieldInfo += 'or abort.\r\r';
      if (testMethod === 'drill' && canContinue) {
        txtFieldInfo +=
          'To ' +
          testMethod +
          ' to an elevation deeper than the ones shown in the dropdown menu, select the deepest one, then press the ' +
          testMethod +
          ' button and repeat until you reach the desired elevation.\r\r';
      }
      txtFieldInfo +=
        'You will receive groundwater samples for every ten foot interval you ' +
        testMethod +
        ' through, and may analyze them at any time.';

      this.txtFieldInfo = txtFieldInfo;

      let elevations = [];
      let i;
      if (canContinue) {
        for (
          i = testZ - 10;
          i >= testZ - 100 && !(testMethod === 'push' && i < _loc13);
          i -= 10
        ) {
          elevations.push({ title: i + 'ft', data: i });
        }
        if (testMethod === 'drill') {
          elevations.push({ title: '(shortcut: bedrock)', data: 0 });
        }
      }
      this.elevations = elevations;

      let wellElevations = [];

      let wellElevation;
      for (i = Math.floor(geoData.waterTable / 10) * 10; i >= testZ; i -= 10) {
        wellElevation = i + 'ft';
        for (let screen in testDataWell.wellScreens) {
          if (testDataWell.wellScreens[screen] === i) {
            wellElevation += ' (already done)';
            break;
          }
        }
        wellElevations.push({ title: wellElevation, data: i });
      }
      this.wellElevations = wellElevations;

      this.drillCallback = () => {
        props.onCancel();
        testingAPI.drilling(
          props.dispatch.bind(null, RESET_POPUP),
          elevations[this.state.drillPushValue].data,
        );
        this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
      };
      this.installWellCallback = () => {
        props.onCancel();
        testingAPI.installWell(
          wellElevations[this.state.wallElevationValue].data,
        );
        this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
      };

      this.onDrillPushChange = this.onDrillPushChange.bind(this);
      this.onWellChange = this.onWellChange.bind(this);
    }

    onDrillPushChange(value) {
      this.setState({ drillPushValue: value });
    }

    onWellChange(value) {
      this.setState({ wallElevationValue: value });
    }

    componentDidMount() {
      this.onWellChange(this.wellElevations.length - 1);
    }

    render() {
      let props = this.props;

      return (
        <div className={`${styles.container} ${commonStyles.font}`}>
          <header>
            <h2>{this.testMethodLabel}</h2>
          </header>
          <ScrollBlock className={styles.scrollBlock} light={true}>
            {utils.multilineTextToArray(this.txtFieldInfo).map((val, idx) => (
              <div key={idx}>{val}</div>
            ))}
          </ScrollBlock>
          {this.canContinue && (
            <div className={styles.container_small}>
              <span>{'Attempt to ' + this.testMethod + ' to elevation:'}</span>
              <Dropdown
                className={styles.dropdown}
                config={{ header: '', items: this.elevations }}
                onChange={this.onDrillPushChange}
                value={this.state.drillPushValue}
                light={true}
              />
              <Button
                onClick={this.drillCallback}
                className={styles.button}
                light={true}>
                {this.testMethodBtnLabel}
              </Button>
            </div>
          )}

          <div className={styles.container_small}>
            <span>Install well at elevation:</span>
            <Dropdown
              className={styles.dropdown}
              config={{ header: '', items: this.wellElevations }}
              onChange={this.onWellChange}
              value={this.state.wallElevationValue}
              light={true}
            />
            <Button
              onClick={this.installWellCallback}
              className={styles.button}
              light={true}>
              Install
            </Button>
          </div>

          <Button
            onClick={props.onCancel}
            className={styles.abort}
            light={true}>
            Abort
          </Button>
        </div>
      );
    }
  }

  class AnalysisDBoxBuilder extends React.Component {
    constructor(props) {
      super(props);

      this.state = { elevationValue: 0 };

      let method = testingAPI.testState.method;
      let _loc23 = method.substring(0, method.indexOf('_'));
      let analysisInfo = comm.dataStore.analysisInfo[method];
      this.displayName = analysisInfo.displayName;
      let testDataDrilling = comm.dataStore.getTestData(
        'drilling',
        testingAPI.testState.x,
        testingAPI.testState.y,
      );
      let testDataAnalysis = comm.dataStore.getTestData(
        'analysis',
        testingAPI.testState.x,
        testingAPI.testState.y,
      );
      let geoData = testingAPI.testState.geoData;
      let analyzedDone = [];
      let analyzedNot = [];
      let elevationArray = [];

      let deepestMin;
      if (_loc23 === 'soil') {
        deepestMin = Math.min(
          testDataDrilling.deepestPushed,
          testDataDrilling.deepestDrilled,
        );
        elevationArray = testingAPI.buildElevationArray(
          deepestMin,
          geoData.surface,
        );
      } else {
        let deepestPushed = testDataDrilling.deepestPushed;
        if (deepestPushed === null) {
          deepestPushed = geoData.surface;
        }
        let deepestDrilled = testDataDrilling.deepestDrilled;
        if (deepestDrilled === null) {
          deepestDrilled = geoData.surface;
        }
        deepestMin = Math.min(deepestPushed, deepestDrilled);
        elevationArray = testingAPI.buildElevationArray(
          deepestMin,
          Math.floor(geoData.waterTable / 10) * 10,
        );
      }
      var analysisResults = testDataAnalysis.analyzedOrNot(
        method,
        elevationArray,
      );
      if (analysisResults != null) {
        analyzedDone = analysisResults.analyzed;
        analyzedNot = analysisResults.notAnalyzed;
      }

      let txtFieldInfo = analysisInfo.description + '\r\r';
      if (_loc23 === 'soil') {
        txtFieldInfo +=
          'You have soil samples as deep as you have gone using either drilling or direct push.';
      } else {
        txtFieldInfo +=
          "You have groundwater samples from every elevation between the water table and the deepest elevation you've drilled or pushed.";
      }
      this.txtFieldInfo = txtFieldInfo;

      let elevationOptions = [];

      let idx;
      let elevation;
      for (idx = analyzedNot.length - 1; idx >= 0; idx--) {
        elevation = analyzedNot[idx];
        elevationOptions.push({ title: elevation + 'ft', data: elevation });
      }

      if (analyzedNot.length === 0) {
        elevationOptions.push({ title: '(none)', data: 'none' });
      }
      this.analyzedNot = analyzedNot;
      this.elevationOptions = elevationOptions;

      this.performAnalysisCallback = () => {
        this.props.onCancel();
        testingAPI.analysis(
          props.dispatch.bind(null, RESET_POPUP),
          elevationOptions[this.state.elevationValue].data,
        );
        this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
      };

      let headers = ['Elev.'];
      let units = ['(ft)'];
      for (idx = 0; idx < analysisInfo.properties.length; idx++) {
        let properties = analysisInfo.properties[idx];
        headers.push(properties.label);
        units.push('(' + properties.units + ')');
      }

      this.headers = headers;
      this.units = units;
      this.colNum = units.length;

      let txtFieldData; //superCreateTF(dBox_mc, "data_txt", 5, 166, _loc16 - 27, 80, "", customTabTextFormat, bigTextBlockInitObj);
      let fields = [];

      for (idx = 0; idx < analyzedDone.length; idx++) {
        elevation = analyzedDone[idx];
        txtFieldData += /*padLeft*/ elevation /*, 5*/;
        fields.push([elevation]);
        for (let i = 0; i < analysisInfo.properties.length; ++i) {
          let _loc4 = analysisInfo.properties[i];
          var _loc1 = testDataAnalysis.getCachedData(method, elevation);
          if (_loc1 === null || typeof _loc1 === 'undefined') {
            _loc1 = testingDataAPI.sampleAnalysis(
              testingAPI.testState.x / 10,
              testingAPI.testState.y / 10,
              elevation,
              method,
            );
            testDataAnalysis.update(method, elevation, _loc1);
          }
          txtFieldData +=
            '\t' +
            /*padLeft*/ String(
              _loc1[_loc4.internalName],
            ) /*, _loc4.label.length*/;
          fields[idx].push(String(_loc1[_loc4.internalName]));
        }
        txtFieldData += '\r';
      }
      this.txtFieldData = txtFieldData;
      this.fields = fields;

      //customTabTextFormat.tabStops = analysisInfo.tabStops;

      this.onElevationChange = this.onElevationChange.bind(this);
    }

    onElevationChange(value) {
      this.setState({ elevationValue: value });
    }

    render() {
      const colStyle = {
        width: Math.floor(100 / this.colNum - 2) + '%',
        textAlign: 'center'
      };

      return (
        <div className={`${styles.container} ${commonStyles.font}`}>
          <header>
            <h2>Sample Analysis</h2>
          </header>
          <div className='container_tiny'>{this.displayName}</div>
          <div className={`${styles.scrollBlock} ${styles.scrollAnalysis}`}>
            {utils.multilineTextToArray(this.txtFieldInfo).map((val, idx) => (
              <div key={idx}>{val}</div>
            ))}
          </div>

          <div className={styles.container_small}>
            <span>Choose an elevation:</span>
            <Dropdown
              className={styles.dropdown}
              config={{ header: '', items: this.elevationOptions }}
              onChange={this.onElevationChange}
              value={this.state.elevationValue}
              light={true}
            />
            {this.analyzedNot.length > 0 && (
              <Button
                onClick={this.performAnalysisCallback}
                className={`${styles.button} ${styles.wide}`}
                light={true}>
                Perform Analysis
              </Button>
            )}
          </div>

          <table>
            <thead>
              <tr>
                {this.headers.map((val, idx) => (
                  <th key={idx} style={colStyle}>
                    <div>{val}</div>
                    <div>{this.units[idx]}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {this.fields.map((row, idx) => (
                <tr key={idx}>
                  {row.map((field, jdx) => (
                    <td style={colStyle} key={jdx}>
                      {field}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          <Button
            onClick={this.props.onCancel}
            className={styles.abort}
            light={true}>
            Done
          </Button>
        </div>
      );
    }
  }

  function InterviewBoxBuilder(locationName) {
    return class InterviewDBoxBuilder extends React.Component {
      constructor(props) {
        super(props);

        this.locInfo = comm.dataStore.locations[locationName];

        this.person = this.locInfo.person;
        this.questions = comm.dataStore.questions;

        this.askQuestionParametrized = Array.apply(
          null,
          Array(this.questions.length),
        ).map((v, idx) => this.askQuestion.bind(this, idx));

        if (this.person.useVideo) {
          this.answers = Array.apply(null, Array(9)).map(
            () => '(See video for answer)',
          );
        } else {
          this.answers = this.person.answers;
        }

        this.state = {
          answered: [],
          vidSrc: this.person.useVideo
            ? `${videoPublicUrl}${this.person.videoPrefix}0.mp4`
            : '',
        };
      }

      askQuestion(questionNumber) {
        let answered = this.state.answered.slice();
        answered.push(questionNumber);
        let newState = { answered };
        if (this.person.useVideo) {
          newState.vidSrc = `${videoPublicUrl}${
            this.person.videoPrefix
          }${questionNumber + 1}.mp4`;
        }
        this.setState(newState);

        comm.dataStore.saveQuestion(this.person.internalName, 1); // todo: what to do with this next?
        if (questionNumber === 0) {
          if (this.person.documents.length > 0) {
            for (let i = 0; i < this.person.documents.length; i++) {
              comm.dataStore.saveReceivedDocument(this.person.documents[i]);
            }
          }
        }
        this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
      }

      render() {
        let props = this.props;

        return (
          <div className={commonStyles.font}>
            <header>
              <h2>{'Visiting ' + this.locInfo.displayName}</h2>
            </header>

            <div className={styles.leftPanel}>
              <div className={styles.instructions}>
                Instructions: Click the icon "
                <div className={styles.iconBalloon} />" below each question you
                would like to ask. Each question costs you $1. When you are
                finished, click the "Leave" button.
              </div>

              <div className={styles.interviewMedia}>
                {this.person.useVideo && (
                  <video
                    width='320'
                    height='240'
                    autoPlay={true}
                    src={this.state.vidSrc}
                  />
                )}
                {!this.person.useVideo && (
                  <img
                    src={charImgs[this.person.internalName]}
                    alt='The person being interviewed'
                  />
                )}
              </div>

              <div className={styles.personInfo}>{this.person.caption}</div>
            </div>

            <div className={styles.rightPanel}>
              <ScrollBlock
                className={styles.scrollInterview}
                light={true}
                disableAutoScrollTop={true}
                lightBackground={true}>
                {this.questions.map((question, idx) => (
                  <div key={idx}>
                    <div className={styles.question}>{question}</div>
                    <div>
                      {this.state.answered.indexOf(idx) > -1 ? (
                        <div className={styles.answer}>{this.answers[idx]}</div>
                      ) : (
                        <div className={styles.buttonInterviewOuter}>
                          <IconButton
                            onClick={this.askQuestionParametrized[idx]}
                            icon='speech'
                          />
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </ScrollBlock>
            </div>

            <Button
              onClick={props.onCancel}
              className={styles.abort}
              light={true}>
              Leave and return to map
            </Button>
          </div>
        );
      }
    };
  }

  function NobodyDBoxBuilder(locationName) {
    return function(props) {
      let location = comm.dataStore.locations[locationName];

      return (
        <div className={`${styles.container} ${commonStyles.font}`}>
          <header>
            <h2>{'Visiting ' + location.displayName}</h2>
          </header>
          <div className={styles.container_tiny}>
            Nobody was found at this location.
          </div>
          <Button
            onClick={props.onCancel}
            className={styles.abort}
            light={true}>
            OK
          </Button>
        </div>
      );
    };
  }

  function DocumentsFixedList(docList, loadedDocs) {
    return class DocumentsBuilder extends React.Component {
      constructor(props) {
        super(props);

        this.docNames = docList.map(obj => obj.data);

        this.state = {
          curDoc: 0,
          curPage: 1,
        };

        this.stepForward = this.stepForward.bind(this);
        this.stepBackward = this.stepBackward.bind(this);
        this.onChange = this.onChange.bind(this);
      }

      onChange(newVal) {
        this.setState({ curDoc: newVal, curPage: 1 });
      }

      stepForward() {
        if (
          this.state.curPage <
          loadedDocs[this.docNames[this.state.curDoc]].numPages
        ) {
          this.setState({ curPage: this.state.curPage + 1 });
        }
      }

      stepBackward() {
        if (this.state.curPage > 1) {
          this.setState({ curPage: this.state.curPage - 1 });
        }
      }

      /*
      * Page numbering markup:
       <div className={styles.group}>
       <Button onClick={this.stepBackward}
       disabled={this.state.curPage === 1}
       className={styles.stepBackward} light={true}><div className={styles.arrowElement}><div className={styles.arrowLeft} /></div></Button>
       <span
       className={styles.pageCounter}>{`${this.state.curPage}/${loadedDocs[this.docNames[this.state.curDoc]].numPages}`}</span>
       <Button onClick={this.stepForward}
       disabled={this.state.curPage === loadedDocs[this.docNames[this.state.curDoc]].numPages}
       className={styles.stepForward} light={true}><div className={styles.arrowElement}><div className={styles.arrowRight} /></div></Button>
       </div>*/

      render() {
        let props = this.props;
        let currDoc = this.docNames[this.state.curDoc];

        return (
          <div className={`${commonStyles.font} ${styles.documentsContainer}`}>
            <header>
              <h2>Documents</h2>
            </header>

            {currDoc === 'youtube' ? (
              <div className={styles.youtube}>
                <ScrollBlock wide={true} light={true} lightBackground={true}>
                  <iframe
                    width='100%'
                    height='700px'
                    className={styles.iframe}
                    src={youtubeVideos[this.state.curDoc][0]}
                  />
                  <iframe
                    width='100%'
                    height='700px'
                    className={styles.iframe}
                    src={youtubeVideos[this.state.curDoc][1]}
                  />
                </ScrollBlock>
              </div>
            ) : (
              <ScrollBlockImage
                className={styles.scrollDocs}
                light={true}
                lightBackground={true}
                src={docImgs[this.docNames[this.state.curDoc]]}
                alt='A document page'
              />
            )}

            <div className={styles.groupsRow}>
              <div className={styles.group}>
                <span>Choose Document:</span>
                <Dropdown
                  onChange={this.onChange}
                  className={styles.dropdown}
                  value={this.state.curDoc}
                  light={true}
                  config={{
                    header: '',
                    defaultDirection: false,
                    items: docList,
                  }}
                />
              </div>

              <div className={styles.group}>
                {currDoc !== 'youtube' && (
                  <a
                    href={pdfDocs[this.docNames[this.state.curDoc]]}
                    target='_blank'
                    download={this.docNames[this.state.curDoc] + '.pdf'}>
                    <Button className={styles.downloadButton} light={true}>
                      Download
                    </Button>
                  </a>
                )}
                <Button
                  onClick={props.onCancel}
                  className={styles.abort}
                  light={true}>
                  Close
                </Button>
              </div>
            </div>
          </div>
        );
      }
    };
  }

  function BudgetFixedList(list) {
    const backupText =
      'In this space you will see the history of all your expenses. ' +
      'Be sure to check how much an action costs before carrying it out and to periodically check your history';
    return function BudgetList(props) {
      return (
        <div className={`${commonStyles.font}`}>
          <header>
            <h2>Expenditures</h2>
          </header>
          <ScrollBlock
            className={styles.scrollBudget}
            wide={true}
            light={true}
            lightBackground={true}>
            {!!list && (
              <div
                className={styles.budgetList}
                dangerouslySetInnerHTML={{ __html: list }}
              />
            )}
            {!list && (
              <div className={`${styles.budgetList} ${styles.budgetEmpty}`}>
                {backupText}
              </div>
            )}
          </ScrollBlock>

          <Button
            onClick={props.onCancel}
            className={styles.abort}
            light={true}>
            OK
          </Button>
        </div>
      );
    };
  }

  function getErrorBox(message) {
    return function ErrorDBoxBuilder(props) {
      return (
        <div className={`${styles.container} ${commonStyles.font}`}>
          <header>
            <h2>Error!</h2>
          </header>
          <div className={styles.container_tiny}>
            {typeof message === 'string'
              ? message
              : message.map((str, idx) => <div key={idx}>{str}</div>)}
          </div>
          <Button
            onClick={props.onCancel}
            className={styles.abort}
            light={true}>
            Ok
          </Button>
        </div>
      );
    };
  }
  function saveErrorDBoxBuilder(type) {
    return class ErrorDBoxBuilder extends Component {
      constructor(props) {
        super(props);

        this.retry = () => {
          this.props.onCancel();
          if (type === 'test') {
            comm.saveTest(comm.syncBuffer[0]);
          } else {
            comm.saveInfo(comm.syncBuffer[0]);
          }
        };
      }

      render() {
        return (
          <div className={`${styles.container} ${commonStyles.font}`}>
            <header>
              <h2>Save Error!</h2>
            </header>
            <div className={styles.container_tiny}>
              <div>
                An error occurred while trying to save your data to the server.
              </div>
              <div>
                Please confirm you are connected to the Internet and then click
                try again. If you are unable to reconnect, close your browser
                window and log in again. You may have lost the most recent data
                collected.
              </div>
            </div>
            <Button onClick={this.retry} className={styles.abort} light={true}>
              Try Again
            </Button>
          </div>
        );
      }
    };
  }

  if (foundation.indexOf('error') > -1) {
    if (foundation.indexOf(error_custom_prefix) > -1) {
      let message = foundation.substring(error_custom_prefix.length);
      return getErrorBox(ERROR_MSG[error_custom_prefix](message).split('|'));
    } else if (foundation.indexOf(error_retry_prefix) > -1) {
      return saveErrorDBoxBuilder(
        foundation.substring(error_retry_prefix.length),
      );
    }
    return getErrorBox(ERROR_MSG[foundation]);
  } else if (foundation.indexOf('analysis') > -1) {
    return branch({}, AnalysisDBoxBuilder);
  } else if (foundation.indexOf('interview') > -1) {
    return branch({}, InterviewBoxBuilder(foundation.substring(10)));
  } else if (foundation.indexOf('_nobody_') > -1) {
    return branch(
      {},
      NobodyDBoxBuilder(
        foundation.substring(foundation.indexOf('_nobody_') + 8),
      ),
    );
  } else if (foundation.indexOf('documents') > -1) {
    return branch(
      {},
      DocumentsFixedList(
        comm.dataStore.documentsCBDP,
        comm.dataStore.documents,
      ),
    );
  } else if (foundation.indexOf('budget') > -1) {
    return branch({}, BudgetFixedList(comm.dataStore.budgetString));
  } else {
    return branch({}, DrillingDBoxBuilder);
  }
}

export default DBoxWithFoundation;
